import FormattedMessage from 'I18n/components/FormattedMessage';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useStrategy } from '../../hooks/useStrategy';
import { useContext } from 'react';
import { RemoveIcon, SuccessIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const variants = {
  failure: {
    IconComponent: RemoveIcon,
    iconColor: 'icon-alert-default',
    message: 'customerDataFiltersUI.testFilters.overallStatusMessageFailure'
  },
  success: {
    IconComponent: SuccessIcon,
    iconColor: 'fill-positive-default',
    message: 'customerDataFiltersUI.testFilters.overallStatusMessageSuccess'
  }
};
const RollupTestFiltersStatusMessage = props => {
  const {
    use
  } = props;
  const {
    props: {
      baseFilterFamily
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    getFilterFamilyObjectName
  } = useStrategy();
  const variant = variants[use];
  if (!variant) {
    return null;
  }
  const objectType = getFilterFamilyObjectName(baseFilterFamily);
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    justify: "between",
    marginBlockStart: "300",
    marginInlineStart: "300",
    paddingInlineEnd: "800",
    children: [/*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: variant.message,
        options: {
          objectType
        }
      })
    }), /*#__PURE__*/_jsx(variant.IconComponent, {
      color: variant.iconColor,
      size: "500"
    })]
  });
};
export default RollupTestFiltersStatusMessage;